(() => {
  const activate = (swatch) => {
    const card = swatch.closest('[data-tb-card]');
    if (!card) return;
    const photo = card.querySelector('.tb-card-image');
    if (photo && swatch.dataset.image) {
      photo.removeAttribute('srcset');
      photo.src = swatch.dataset.image;
      photo.alt = swatch.getAttribute('aria-label');
    }
    card.querySelectorAll('[data-tb-product-link]').forEach(a => { a.href = swatch.href; });
    card.querySelectorAll('[data-tb-swatch]').forEach(a => a.classList.toggle('is-selected', a === swatch));
    const label = card.querySelector('[data-tb-colour]');
    if (label) label.textContent = swatch.dataset.colour;
  };
  document.addEventListener('pointerover', e => { const s = e.target.closest('[data-tb-swatch]'); if (s) activate(s); });
  document.addEventListener('focusin', e => { const s = e.target.closest('[data-tb-swatch]'); if (s) activate(s); });
  document.addEventListener('click', e => { const s = e.target.closest('[data-tb-swatch]'); if (!s || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return; e.preventDefault(); activate(s); });
})();
